import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const CommentIcon = ({ size = 16, color = 'currentFill' }: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 16 15"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M-.083 3A2.75 2.75 0 0 1 2.667.25h10A2.75 2.75 0 0 1 15.417 3v6a2.75 2.75 0 0 1-2.75 2.75H8.612l-4.006 3.171a.75.75 0 0 1-1.215-.588V11.75h-.724A2.75 2.75 0 0 1-.083 9V3Zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v6c0 .69.56 1.25 1.25 1.25h1.474a.75.75 0 0 1 .75.75v1.783l2.995-2.371a.75.75 0 0 1 .465-.162h4.316c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25h-10Zm.583 2.917a.75.75 0 0 1 .75-.75h7.334a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75ZM4 6.583a.75.75 0 1 0 0 1.5h4a.75.75 0 1 0 0-1.5H4Z"/>
    </svg>
);
CommentIcon.displayName = 'CommentIcon';
export default CommentIcon;
